import { render, staticRenderFns } from "./failed-certification.vue?vue&type=template&id=3b0a7b5c&scoped=true&"
import script from "./failed-certification.vue?vue&type=script&lang=js&"
export * from "./failed-certification.vue?vue&type=script&lang=js&"
import style0 from "./failed-certification.vue?vue&type=style&index=0&id=3b0a7b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a7b5c",
  null
  
)

export default component.exports